import _defineProperty from "/vercel/path0/apps/legacy-open/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { isProduction } from '@/lib/env-utils';
import Logger from '@/lib/logger';
import IconFaceAstonished from '@/icons/face-astonished.svg';
import theme from '@/theme';
import UIButton from '@/components/ui/button';
import UIIcon from '@/components/ui/icon';
import StyledErrorPage from './styled';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var statusTextMessages = defineMessages({
  403: {
    id: 'error.page.403.statusText'
  },
  404: {
    id: 'error.page.404.statusText'
  },
  "default": {
    id: 'error.page.default.statusText'
  },
  offline: {
    id: 'error.page.offline.statusText'
  },
  timeout: {
    id: 'error.page.timeout.statusText'
  },
  unavailable: {
    id: 'error.page.unavailable.statusText'
  }
});
var infoMessages = defineMessages({
  403: {
    id: 'error.page.403.info'
  },
  404: {
    id: 'error.page.404.info'
  },
  "default": {
    id: 'error.page.default.info'
  },
  offline: {
    id: 'error.page.offline.info'
  },
  timeout: {
    id: 'error.page.timeout.info'
  },
  unavailable: {
    id: 'error.page.unavailable.info'
  }
});

var ErrorPage = function ErrorPage(_ref) {
  var actionLabel = _ref.actionLabel,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? null : _ref$error,
      _ref$extraInfo = _ref.extraInfo,
      extraInfo = _ref$extraInfo === void 0 ? null : _ref$extraInfo,
      icon = _ref.icon,
      _ref$reportable = _ref.reportable,
      reportable = _ref$reportable === void 0 ? true : _ref$reportable,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      _ref$onActionClick = _ref.onActionClick,
      onActionClick = _ref$onActionClick === void 0 ? function () {} : _ref$onActionClick;
  var hasActionLabel = Boolean(actionLabel);
  var hasExtrInfo = Boolean(extraInfo);
  var hasIcon = Boolean(icon);

  var onFillReportClick = function onFillReportClick() {
    Logger.report();
  };

  return /*#__PURE__*/_jsxs(StyledErrorPage, {
    children: [/*#__PURE__*/_jsx("h1", {
      children: hasIcon ? /*#__PURE__*/_jsx(_Fragment, {
        children: icon
      }) : /*#__PURE__*/_jsx(UIIcon, {
        as: IconFaceAstonished,
        color: theme['error.icon.color'],
        size: 196
      })
    }), /*#__PURE__*/_jsx("h2", {
      children: /*#__PURE__*/_jsx(FormattedMessage, _objectSpread({}, statusTextMessages[type]))
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, _objectSpread({}, infoMessages[type]))
    }), !isProduction() && error && /*#__PURE__*/_jsxs("pre", {
      children: [error.message, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), error.stack]
    }), hasExtrInfo && /*#__PURE__*/_jsx(_Fragment, {
      children: extraInfo
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UIButton, {
        textTransform: "uppercase",
        variant: reportable ? 'secondary' : 'primary',
        onClick: onActionClick,
        children: hasActionLabel ? /*#__PURE__*/_jsx(_Fragment, {
          children: actionLabel
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          id: "retry"
        })
      }), reportable && /*#__PURE__*/_jsxs(_Fragment, {
        children: [' ', /*#__PURE__*/_jsx(UIButton, {
          textTransform: "uppercase",
          variant: "primary",
          onClick: onFillReportClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "error.page.fillReport"
          })
        })]
      })]
    })]
  });
};

export default ErrorPage;